import { useCallback, useState } from 'react';

export const useActiveStep = (length) => {
    const [activeStep, setActiveStep] = useState(1);

    const prev = useCallback(() => {
        if (activeStep - 1 < 1) {
            setActiveStep(length);
        } else {
            setActiveStep(activeStep - 1);
        }
    }, [activeStep, length]);

    const next = useCallback(() => {
        if (activeStep + 1 > length) {
            setActiveStep(1);
        } else {
            setActiveStep(activeStep + 1);
        }
    }, [activeStep, length]);

    const resetStep = useCallback(() => {
        setActiveStep(1);
    }, []);

    return { activeStep, prev, next, resetStep };
};
